import { observer } from "mobx-react";
import { useEffect } from "react";
import dashboardSettingsStore, { ThemeName } from "../../stores/dashboard-settings-store";

const DEFAULT_THEME = ThemeName.DEFAULT;
const FAVICON_BY_THEME: Record<ThemeName, string> = {
    [ThemeName.DEFAULT]: "/favicon.ico",
    [ThemeName.GLOBAL_E]: "/favicon-global-e.png",
};

/**
 * ThemeProvider applies the enabled theme as a class on the document and sets the favicon.
 * Uses theme_name from dashboard settings; falls back to default if unknown.
 */
export const ThemeProvider: React.FC<{ children: React.ReactNode }> = observer(({ children }) => {
    // Access the value inside observer to ensure reactivity
    const themeName = dashboardSettingsStore.themeName;
    const faviconHref = FAVICON_BY_THEME[themeName] ?? FAVICON_BY_THEME[DEFAULT_THEME];

    useEffect(() => {
        const htmlElement = document.documentElement;
        htmlElement.classList.add(themeName);

        let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
        if (!link) {
            link = document.createElement("link");
            link.rel = "icon";
            document.head.appendChild(link);
        }
        link.href = faviconHref;
    }, [themeName, faviconHref]);

    return <>{children}</>;
});

